import { makeAutoObservable } from "mobx";
class debugComponent {
  constructor() {
    makeAutoObservable(this);
  }
  setParameters = (parametr, value) => {
    this[`${parametr}`] = value;
  };
  // random_log = false;
}
export default new debugComponent();
